<section class="index-banner-inner pad" style="background-image: url(assets/images/Reg_form.jpg);">
	<div class="container-fluid">
		<div class="container">
			<h2 class="title-banner mbtm20">Registration Form</h2>
			<!-- <div class="button-blue"><a href="#">
					<strong>Book For Demo</strong>
				</a>
			</div> -->
		</div>
	</div>
</section>
<section class="Form-page pt-70 pb-70">
	<div class="container-fluid">
		<div class="row justify-content-center">
			<div class="col-md-6">
				<!-- form card login -->
				<div class="card card-outline-secondary">
					<div class="card-header">
						<h3 class="mb-0">Registration</h3>
					</div>
					<div class="card-body">
						<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" >
							<input type="hidden" name="id" id="id" [(ngModel)]="tenantDetails.id" formControlName="id" /> 
							<input type="hidden" name="tenantPackageID" id="tenantPackageID" [(ngModel)]="tenantDetails.tenantPackageID" formControlName="id" value="{{tenantDetails.tenantPackageID}}" />
							<div class="form-group">
								<label>Organization Name <span class="red">*</span></label>
								<input type="text" [(ngModel)]="tenantDetails.orgName" class="form-control" formControlName="orgName" [ngClass]="{ 'is-invalid': submitted && f.orgName.errors }" />
								<div *ngIf="submitted && f.orgName.errors" class="invalid-feedback">
									<div *ngIf="f.orgName.errors.required">Organization Name is required</div>
									<div *ngIf="f.orgName.errors.maxlength">Please enter upto 100 characters</div>
									<div *ngIf="f.orgName.errors.pattern">Organization name must contain alpha numeric & space only</div>
									<div *ngIf="f.orgName.errors.noWhiteSpace">Blank spaces are not allowed</div>
								</div>
							</div>
							<div class="form-group">
								<label for="email">Email ID <span class="red">*</span></label>
								<input type="text" [(ngModel)]="tenantDetails.tenantEmail" class="form-control emailClass" formControlName="tenantEmail" [ngClass]="{ 'is-invalid': submitted && f.tenantEmail.errors }" /> 
								<div *ngIf="submitted && f.tenantEmail.errors" class="invalid-feedback">
									<div *ngIf="f.tenantEmail.errors.required">Email ID is required</div>
									<div *ngIf="f.tenantEmail.errors.email">Email ID must be a valid email address</div>
									<div *ngIf="f.tenantEmail.errors.pattern">Email ID must be a valid email address</div>
									<div *ngIf="f.tenantEmail.errors.maxlength">Please enter upto 150 characters</div>
								</div>
							</div>
							<div class="form-group">
								<label>Contact No <span class="red">*</span></label>
								<input type="text" [(ngModel)]="tenantDetails.contactNumber" class="form-control" formControlName="contactNumber" [ngClass]="{ 'is-invalid': submitted && f.contactNumber.errors }" />
								<div *ngIf="submitted && f.contactNumber.errors" class="invalid-feedback">
									<div *ngIf="f.contactNumber.errors.required">Contact Number is required</div>
									<div *ngIf="f.contactNumber.errors.pattern">Please enter valid contact number</div>
								</div>
							</div>
							<div class="form-group">
								<label for="uname1">Contact Person Name <span class="red">*</span></label>
								<input type="text" [(ngModel)]="tenantDetails.tenantName" class="form-control" formControlName="tenantName" [ngClass]="{ 'is-invalid': submitted && f.tenantName.errors }" size="10"/>
								<div *ngIf="submitted && f.tenantName.errors" class="invalid-feedback">
									<div *ngIf="f.tenantName.errors.required">Contact Person Name is required</div>
									<div *ngIf="f.tenantName.errors.pattern">Contact Person Name must contain alpha characters & space only</div>
									<div *ngIf="f.tenantName.errors.maxlength">Please enter upto 50 characters</div>
									<div *ngIf="f.tenantName.errors.noWhiteSpace">Blank spaces are not allowed</div>
								</div>
							</div>
							<div class="form-group">
								<label>Designation <span class="red">*</span></label>
								<input type="text" [(ngModel)]="tenantDetails.designation" class="form-control" formControlName="designation" [ngClass]="{ 'is-invalid': submitted && f.designation.errors }" />
								<div *ngIf="submitted && f.designation.errors" class="invalid-feedback">
									<div *ngIf="f.designation.errors.required">Designation is required</div>
									<div *ngIf="f.designation.errors.maxlength">Please enter upto 100 characters</div>
									<div *ngIf="f.designation.errors.pattern">Designation must contain alpha characters & space only</div>
									<div *ngIf="f.designation.errors.noWhiteSpace">Blank spaces are not allowed</div>
								</div>
							</div>
							<div class="form-group">
								<label>GST No <small><i>(optional)</i></small></label>
								<input type="text" [(ngModel)]="tenantDetails.gstinNo" class="form-control" formControlName="gstinNo" [ngClass]="{ 'is-invalid': submitted && f.gstinNo.errors }" maxlength="15" />
								<div *ngIf="submitted && f.gstinNo.errors" class="invalid-feedback">
									<div *ngIf="f.gstinNo.errors.pattern">GST No must contain alpha numeric only</div>
									<div *ngIf="f.gstinNo.errors.maxlength">Please enter upto 15 characters</div>
									<!-- <div *ngIf="f.gstinNo.errors.noWhiteSpace">White and empty spaces are not allowed</div> -->
								</div>
							</div>
							<div class="form-group">
								<label>Address <small><i>(Ex. Format: #1, North Street, Chennai - 11)</i></small> <span class="red"> *</span></label>
								<input type="text" class="form-control"  [(ngModel)]="tenantDetails.address" formControlName="address" [ngClass]="{ 'is-invalid': submitted && f.address.errors }" />
								<div *ngIf="submitted && f.address.errors" class="invalid-feedback">
									<div *ngIf="f.address.errors.pattern">Please enter valid Address</div>
									<div *ngIf="f.address.errors.required">Address is required</div>
									<div *ngIf="f.address.errors.maxlength">Please enter upto 100 characters</div>
									<div *ngIf="f.address.errors.noWhiteSpace">Blank spaces are not allowed</div>
								</div>
							</div>
							<recaptcha 
								[size]="'invisible'"
								[hide]="true" 
								(captchaResponse)="onCaptchaResponse($event)">
							</recaptcha>
							<hr>
							<input type="hidden" [(ngModel)]="tenantDetails.token" id="token" class="form-control" formControlName="token" />
							<div class="form-group text-center">
								<button class="btn btn-primary" [disabled]="isDisabled">Register</button>
							</div>
						</form>
					</div>
				</div>
				<!--/card-block-->
			</div><!-- /form card login -->
		</div>
	</div>
</section>